module.exports = __webpack_public_path__ + "img/2.54962cc2.jpg";